import React, { useState, useCallback } from "react";
import { Button, Popover, OverlayTrigger, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMugHot, faLightbulb } from "@fortawesome/free-solid-svg-icons";
import { notify } from "react-notify-toast";
import { toggleSmartThingsScene } from "../../../services/studentsService";

export default function CoffeeSignal() {
  const [isApiWaiting, setIsApiWaiting] = useState(false);

  const handleCoffeeSignal = useCallback(async (scene) => {
    setIsApiWaiting(true);
    try {
      const response = await toggleSmartThingsScene(scene);
      if (response.success) {
        notify.show("Dispositivo actualizado", "success");
      } else {
        notify.show(response?.message, "error");
      }
    } catch {
      notify.show(
        "No se pudo actualizar el estado del dispositivo, por favor verifique que se encuentre correctamente conectado e intente de nuevo",
        "error"
      );
    } finally {
      setIsApiWaiting(false);
    }
  }, []);

  const handleCoffeeUp = useCallback(() => handleCoffeeSignal("COFFEE_SIGNAL_UP"), [handleCoffeeSignal]);
  const handleCoffeeDown = useCallback(() => handleCoffeeSignal("COFFEE_SIGNAL_DOWN"), [handleCoffeeSignal]);

  const popover = (
    <Popover id="coffee-popover" className="shadow border-0">
      <Popover.Content className="p-2">
        {isApiWaiting ? (
          <div className="d-flex align-items-center p-2">
            <Spinner animation="border" size="sm" className="mr-2 text-primary" />
            <small className="font-weight-bold text-secondary">Brewing coffee...</small>
          </div>
        ) : (
          <div className="d-flex" style={{ gap: "8px" }}>
            <Button
              size="sm"
              variant="outline-warning"
              onClick={handleCoffeeUp}
              title="Encender indicador de café"
              className="d-flex align-items-center"
            >
              <FontAwesomeIcon icon={faLightbulb} className="mr-1" /> On
            </Button>
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={handleCoffeeDown}
              title="Apagar indicador de café"
              className="d-flex align-items-center"
            >
              <FontAwesomeIcon icon={faLightbulb} className="mr-1" /> Off
            </Button>
          </div>
        )}
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger trigger="click" placement="left" overlay={popover} rootClose>
      <Button size="sm" variant="outline-primary" className="rounded-pill px-3 shadow-sm font-weight-bold">
        <FontAwesomeIcon icon={faMugHot} className="mr-1 text-danger" />
        Coffee Signal
      </Button>
    </OverlayTrigger>
  );
}
